import {
  formatQueryRes,
  getDateStr,
  useAppSelector,
  useGetUpgradeRequestQuery
} from '@monorepo/shared';
import CloudReflashIcon from '@rsuite/icons/CloudReflash';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Pagination, Stack, Table } from 'rsuite';
import { selectCurrentAccount } from '@monorepo/shared/store/accountSlice';
interface IProps {
  data: Record<string, any>;
}

export const InstanceTicket = ({ data }: IProps) => {
  const navigate = useNavigate();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const {
    data: upgradeRequestData,
    isError,
    isSuccess,
    isLoading,
    isFetching
  } = useGetUpgradeRequestQuery(
    formatQueryRes({
      account: currentAccount,
      instance_id: data?.instance_id,
      region: data?.region
    }),
    { skip: !data?.region?.token }
  );

  const onClick = () => {
    navigate('ticket', { state: { data: data } });
  };
  return (
    <div className="grid-item ">
      <div className="grid-header">
        <div className="title">
          <CloudReflashIcon style={{ marginRight: '10px' }} />
          Upgrade
        </div>
      </div>
      <div className="grid-content">
        <Stack
          direction="column"
          alignItems="flex-start"
          spacing={14}
          style={{ color: '#48556F' }}
        >
          <div>
            {
              'You can raise an upgrade request for your FortiTIP instance by clicking on "Initiate Upgrade Request" button'
            }
          </div>
          <Button appearance="primary" onClick={() => onClick()} size="xs">
            Initiate Upgrade Request
          </Button>
        </Stack>
        {upgradeRequestData && upgradeRequestData.length ? (
          <Stack direction="column" alignItems="stretch">
            <UpgradeRequestHistory data={upgradeRequestData} />
          </Stack>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export const UpgradeRequestHistory = ({ data }: IProps) => {
  const limits = [5, 10, 15];
  const [limit, setLimit] = useState<number>(limits[0]);
  const [page, setPage] = useState<number>(1);
  const { Column, HeaderCell, Cell } = Table;
  const [tableData, setTableData] = useState<any>([]);
  const [displayData, setDisplayData] = useState<any>([]);
  useEffect(() => {
    if (data?.length) {
      const formattedData = data
        ?.filter((row: Record<string, any>) => row?.visibility !== 'Hide')
        .map((row: Record<string, any>, index: number) => {
          const ctime = new Date(row.ctime * 1000).toISOString();
          const completed = row.completed ? 'Completed' : 'Processing';
          return {
            ...row,
            index,
            ctime,
            completed
          };
        });
      setTableData(formattedData);
    }
  }, [data]);

  useEffect(() => {
    if (page && limit) {
      const displayData = getDisplayData(tableData);
      setDisplayData(displayData);
    }
  }, [page, limit, tableData]);

  const getDisplayData = (accounts: Record<string, any>[]) => {
    const displayData = accounts.filter((v, i) => {
      const start = limit * (page - 1);
      const end = start + limit;
      return i >= start && i < end;
    });
    return displayData;
  };
  const handleChangeLimit = async (pageSize: number) => {
    setPage(1);
    setLimit(pageSize);
  };
  const handleChangePage = async (page: number) => {
    setPage(page);
  };
  return (
    <>
      <div className="upgrade-req-history">
        <Table
          fillHeight
          data={displayData}
          bordered
          cellBordered
          rowHeight={36}
        >
          <Column flexGrow={1}>
            <HeaderCell>Email</HeaderCell>
            <Cell dataKey="name" />
          </Column>
          <Column align="center">
            <HeaderCell> Request Date</HeaderCell>
            <Cell>
              {(rowData: Record<string, any>) => {
                const humanReadable = getDateStr(rowData?.ctime);
                return <span>{humanReadable}</span>;
              }}
            </Cell>
          </Column>
          <Column flexGrow={1}>
            <HeaderCell> Current Version</HeaderCell>
            <Cell dataKey="from_version" />
          </Column>
          <Column flexGrow={1}>
            <HeaderCell> Target Version</HeaderCell>
            <Cell dataKey="to_version" />
          </Column>
          <Column width={80} align="center">
            <HeaderCell>Status</HeaderCell>
            <Cell dataKey="completed" />
          </Column>
        </Table>
      </div>
      <div style={{ padding: 5 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={['total', '-', 'limit', '|', 'pager', 'skip']}
          total={tableData?.length}
          limitOptions={limits}
          limit={limit}
          activePage={page}
          onChangePage={handleChangePage}
          onChangeLimit={handleChangeLimit}
        />
      </div>
    </>
  );
};
